import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';
import styled from '@emotion/styled';

import { BREAKPOINTS, SPACE } from '@/constants';
import { navigateToVehiclePage } from '@/utils/api';
import { logTrackingEvent } from '@/utils/tracking';

import { ExampleText, TabPanel } from './styles';
import { ConnectedSearchInput } from './utils';

const StyledTabPanel = styled(TabPanel)`
  margin-bottom: ${SPACE.X3};

  @media (min-width: ${BREAKPOINTS.LG}px) {
    margin-bottom: calc(${SPACE.X2} + ${SPACE.X0});
  }
`;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'make' implicitly has an 'any' type.
const searchMakeModel = (make, model) => {
  logTrackingEvent({
    event: 'searchMakeModel',
    make,
    model,
  });

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Expected 4-5 arguments, but got 2.
  navigateToVehiclePage(make, model);
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'make' implicitly has an 'any' type.
const onSubmitMakeModel = ({ make, model }) => searchMakeModel(make, model);

const StyledConnectedSearchInput = styled(ConnectedSearchInput)`
  width: 100%;
`;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'searchTopRef' implicitly has an 'any' type.
const SearchBox = ({ searchTopRef, isMobileDevice, isSearchStalled: isLoading, refine, currentRefinement }) => (
  <StyledConnectedSearchInput
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ onSubmitForOption: ({ make, model }: { make: any; model: any; }) => void; searchTopRef: any; isMobileDevice: any; isLoading: any; refine: any; currentRefinement: any; }' is not assignable to type 'IntrinsicAttributes & Omit<{ isLoading: any; refine: any; hits: any; }, HitsProvided<unknown>> & { theme?: Theme | undefined; } & { ref?: Ref<...> | undefined; }'.
    onSubmitForOption={onSubmitMakeModel}
    searchTopRef={searchTopRef}
    isMobileDevice={isMobileDevice}
    isLoading={isLoading}
    refine={refine}
    currentRefinement={currentRefinement}
  />
);

export const MakeModelSearchBox = connectSearchBox(SearchBox);

type MakeModelTabPanelProps = {
  hidden: boolean;
  searchTopRef: React.MutableRefObject<null>;
};

export const MakeModelTabPanel = ({ searchTopRef, hidden }: MakeModelTabPanelProps) => {
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <StyledTabPanel hidden={hidden}>
      <ExampleText>eg. Ford Focus or Mazda CX-5</ExampleText>
      <MakeModelSearchBox
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ onSubmitMakeModel: ({ make, model }: { make: any; model: any; }) => void; searchTopRef: any; isMobileDevice: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<Omit<{ searchTopRef: any; isMobileDevice: any; isSearchStalled: any; refine: any; currentRefinement: any; }, SearchBoxProvided> & SearchBoxExposed, any, any>> & Readonly<...>'.
        onSubmitMakeModel={onSubmitMakeModel}
        searchTopRef={searchTopRef}
        isMobileDevice={isMobileDevice}
      />
    </StyledTabPanel>
  );
};
